import { motion } from 'framer-motion';
import { Terminal, FolderOpen, User, Mail, FileText, Image, Award, BookOpen, Settings } from 'lucide-react';
import { Button } from './ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import TerminalWindow from './windows/TerminalWindow';
import AboutWindow from './windows/AboutWindow';
import SkillsWindow from './windows/SkillsWindow';
import ProjectsWindow from './windows/ProjectsWindow';
import ContactWindow from './windows/ContactWindow';
import ResumeWindow from './windows/ResumeWindow';
import GalleryWindow from './windows/GalleryWindow';
import AchievementsWindow from './windows/AchievementsWindow';
import BlogWindow from './windows/BlogWindow';

export const Taskbar = ({ onOpenWindow, windows, onRestoreWindow }) => {
  const apps = [
    { 
      id: 'terminal', 
      icon: Terminal, 
      label: 'Terminal',
      content: <TerminalWindow />
    },
    { 
      id: 'about', 
      icon: User, 
      label: 'About',
      content: <AboutWindow />
    },
    { 
      id: 'skills', 
      icon: FolderOpen, 
      label: 'Skills',
      content: <SkillsWindow />
    },
    { 
      id: 'projects', 
      icon: FolderOpen, 
      label: 'Projects',
      content: <ProjectsWindow />
    },
    { 
      id: 'contact', 
      icon: Mail, 
      label: 'Contact',
      content: <ContactWindow />
    },
    { 
      id: 'resume', 
      icon: FileText, 
      label: 'Resume',
      content: <ResumeWindow />
    },
    { 
      id: 'gallery', 
      icon: Image, 
      label: 'Gallery',
      content: <GalleryWindow />
    },
    { 
      id: 'achievements', 
      icon: Award, 
      label: 'Achievements',
      content: <AchievementsWindow />
    },
    { 
      id: 'blog', 
      icon: BookOpen, 
      label: 'Blog',
      content: <BlogWindow />
    },
  ];

  return (
    <div className="absolute bottom-0 left-0 right-0 z-50">
      <div className="mx-auto w-fit">
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          className="glass-panel tech-border rounded-t-2xl px-6 py-3 mb-0"
        >
          <TooltipProvider>
            <div className="flex items-center gap-3">
              {/* App Icons */}
              {apps.map((app, i) => {
                const isOpen = windows.some(w => w.appId === app.id);
                return (
                  <Tooltip key={app.id}>
                    <TooltipTrigger asChild>
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: i * 0.05 }}
                      >
                        <Button
                          variant="ghost"
                          size="icon"
                          className={`relative h-12 w-12 rounded-xl transition-all ${
                            isOpen 
                              ? 'bg-primary/20 text-primary border-2 border-primary/50' 
                              : 'hover:bg-primary/10 hover:text-primary border-2 border-transparent'
                          }`}
                          onClick={() => {
                            const openWindow = windows.find(w => w.appId === app.id && w.minimized);
                            if (openWindow) {
                              onRestoreWindow(openWindow.id);
                            } else if (!isOpen) {
                              onOpenWindow(app.id, app.label, app.content);
                            }
                          }}
                        >
                          <app.icon className="w-6 h-6" />
                          {isOpen && (
                            <motion.div
                              layoutId={`indicator-${app.id}`}
                              className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-primary"
                              animate={{ boxShadow: '0 0 8px hsl(200 100% 55%)' }}
                            />
                          )}
                        </Button>
                      </motion.div>
                    </TooltipTrigger>
                    <TooltipContent side="top">
                      <p className="text-xs">{app.label}</p>
                    </TooltipContent>
                  </Tooltip>
                );
              })}

              {/* Separator */}
              <div className="w-px h-8 bg-border" />

              {/* Settings */}
<Tooltip>
  <TooltipTrigger asChild>
    <a rel="noopener noreferrer">
      <Button
        variant="ghost"
        size="icon"
        className="h-12 w-12 rounded-xl hover:bg-accent/10 hover:text-accent border-2 border-transparent transition-all"
      >
        <Settings className="w-6 h-6" />
      </Button>
    </a>
  </TooltipTrigger>
  <TooltipContent side="top">
    <p className="text-xs">Settings</p>
  </TooltipContent>
</Tooltip>
            </div>
          </TooltipProvider>
        </motion.div>
      </div>
    </div>
  );
};

export default Taskbar;
